import NodeLabel from "Areas/SharedFeatures/nodeLabel";
import jsxElementToImgBase64 from "Common/componentUtils/jsxElementToImgBase64";
import urlToBase64 from "Common/componentUtils/urlToBase64";
import startsWith from "lodash/startsWith";
import React from "react";
export const nodeLabelDefaultStyle = {
    padding: 5,
    margin: 0,
    width: 90,
    height: 90
};
export default async (nodeSource, abortController) => {
    let src = nodeSource.NodeImage;
    if (src && !startsWith(src, window.location.origin) && !startsWith(src, "/")) {
        await new Promise(resolve => {
            urlToBase64(src, (res) => {
                if (res)
                    src = res;
                resolve(res);
            });
        });
    }
    const label = (React.createElement(NodeLabel, { imgSize: nodeLabelDefaultStyle.width - nodeLabelDefaultStyle.padding * 2, data: { ...nodeSource, NodeImage: src }, documentObject: nodeSource.DocumentObject, style: nodeLabelDefaultStyle, showName: false, showDocumentObjectName: false }));
    return jsxElementToImgBase64(label, undefined, abortController);
};
